(() => {
  if (window.rxkAddonColorsInitialized) return;
  window.rxkAddonColorsInitialized = true;
  let pending = false;
  function update() {
    pending = false;
    const colors = new Map();
    document.querySelectorAll('[data-rxk-addon-colors]').forEach(source => {
      try {
        JSON.parse(source.textContent).forEach(sample => {
          if (/^\d+$/.test(sample.id) && CSS.supports('color', sample.color)) colors.set(sample.id, sample.color);
        });
      } catch { /* Ignore an incomplete editor update. */ }
    });
    document.querySelectorAll('.rxk-addon-item').forEach(item => {
      const color = colors.get(item.querySelector('[data-addon-id]')?.dataset.addonId);
      const useSample = !!color && !item.querySelector('img.rxk-addon-bild');
      item.toggleAttribute('data-rxk-color-sample', useSample);
      if (useSample) item.style.setProperty('--rxk-addon-color', color);
      else item.style.removeProperty('--rxk-addon-color');
    });
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  }
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true, characterData:true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  schedule();
})();
